/* tslint:disable */
import { BusStation } from './bus-station';

/**
 */
export class dbRouteBusStation {
    bus_station?: BusStation;
    route_name?: string;
}
